import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import Calendar from "./Calendar.vue";
import translations from "../../lang/lang.json";
import CalendarCallback from "./CalendarCallback.vue";
import AppointmentConfirmed from "./AppointmentConfirmed.vue";
import AppointmentAsked from "./AppointmentAsked.vue";
import ErrorModal from "./ErrorModal.vue";

// Plugins
Vue.use(VueI18n);
Vue.use(VueReCaptcha, {
    siteKey: window.GOOGLE_RECAPTCHA_V3_SITE_KEY,
    loaderOptions: {
        autoHideBadge: true // optionnel
    }
});


new Vue({
    el: '#appointment-app',
    i18n: new VueI18n({ locale: 'fr', messages: translations }),
    components: {
        calendar: Calendar,
        calendarCallback : CalendarCallback,
        appointmentConfirmed : AppointmentConfirmed,
        appointmentAsked: AppointmentAsked,
        errorModal: ErrorModal
    },
    data: {
        validSteps: ['APPOINTMENT_AGENDA', 'APPOINTMENT_INFO', 'CALLBACK_INFO', 'APPOINTMENT_CONFIRMED', 'APPOINTMENT_ASKED'],
        step : 'APPOINTMENT_AGENDA',
        store_choose: null,
        first_name : null,
        ics_url : '#'
    },
    computed: {
        previousStepMap(){
            return {
                APPOINTMENT_INFO: "APPOINTMENT_AGENDA",
                APPOINTMENT_CONFIRMED: "APPOINTMENT_INFO",
                CALLBACK_INFO: "APPOINTMENT_AGENDA",
                APPOINTMENT_ASKED: "CALLBACK_INFO"
            }
        }
    },
    methods: {
        handlePrevClick() {
            this.showTimeslotsCalendar = false;
            this.goToPreviousStep();
        },
        goToPreviousStep() {
            if (this.previousStepMap[this.step]) {
                this.step = this.previousStepMap[this.step];
            } else {
                window.handlePrevButtonClick();
                return;
            }
        },
        goToStep(step) {
            if (!this.validSteps.includes(step)) {
                console.warn(`Step ${step} is not valid`);
                return;
            }
            document.body.scrollIntoView({behavior: 'smooth', block: 'start'});
            this.step = step;
        },
        setFirstName(value) {
            this.first_name = value;
        },
        setStoreChoose(value) {
            this.store_choose = value;
        },
        setIcsUrl(value) {
            this.ics_url = value;
        }
    },
    created () {
        window.displayError = msg => this.$refs.errorModal.open(msg)
    }
});
